import { useMemo } from 'react';
import { FindInPage, Image } from '@mui/icons-material';
import { FileModel } from '../../api/models/FileModel';
import { XLSXIcon } from '../../icons';
import { PDFIcon } from '../../icons';

const useGetFileIconByExtension = (fileType: FileModel.file_type, sizeInRem: string = '1.25rem') => {
  switch (fileType) {
    case FileModel.file_type.XLSX:
      return <XLSXIcon sx={{ width: sizeInRem, height: sizeInRem }} />;
    case FileModel.file_type.PDF:
      return <PDFIcon sx={{ width: sizeInRem, height: sizeInRem }} />;
    case FileModel.file_type.PNG:
    case FileModel.file_type.JPEG:
    case FileModel.file_type.JPG:
      return <Image sx={{ width: sizeInRem, height: sizeInRem }} />;
    default:
      return <FindInPage sx={{ width: sizeInRem, height: sizeInRem }} />;
  }
};

export default useGetFileIconByExtension;
